import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "NewsDeleteComment",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const {
  deleteNewsComment,
  deleteNewsCommentError,
  deleteNewsCommentSuccess,
} = slice.actions;

reducerRegistry.register("newsDeleteComment", reducer);
